import { View } from "backbone";
import { getFormData } from "./form-helper";

export default class LandingSearchView extends View {
  preinitialize() {
    this.type = {};

    this.events = {
      submit: this.search,
      "change select[name=type]": this.handleTypeSelect,
    };
  }

  initialize(options) {
    // Set "section" option
    this.section = options.section;
    if (!this.section) {
      throw 'Option "section" cannot be empty';
    }

    // Set "search_url" option
    this.search_url = options.search_url;
  }

  search($e) {
    if ($e instanceof Object) {
      $e.preventDefault();
    }

    // Get criteria
    const criteria = getFormData(this.$el);

    const sectionString =
      this.section === "landing" ? "/search/" : this.search_url["this.section"];

    // Redirect to search page
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.host +
      sectionString +
      "#c=" +
      JSON.stringify(criteria);
  }

  handleTypeSelect() {
    this.setType();
  }

  setType() {
    const typeEl = this.$el.find("[name='type']");
    this.type = typeEl.val();
  }
}
